<template lang="pug">
.pagination_section.col-md-12.col-sm-12.clearfix
  .pull-right
    v-select(
      justified close-on-select
      v-bind:value.sync="countOfPage"
      v-bind:options="countOfPageOptions"
      options-value="val"
      name="countOfPage[]"
      @change="resetPagination"
    )
  .btn-group
    button.btn.btn-default.more(@click='setPaginationSec(currPaginationSec-1)' v-if='currPaginationSec !== 1')
      span.glyphicon.glyphicon-backward
    button.btn.btn-default.more(@click.prevent="setPage(currPage-1)" v-bind:class="{'disabled': (currPage === 1)}")
      span.glyphicon.glyphicon-triangle-left
    button.btn.btn-default.page(@click.prevent="setPage(n+1)" v-for="n in totalPageAry | limitBy countOfPagination paginationStart" v-bind:class="{'active': (currPage === (n+1))}" )  {{n+1}}
    button.btn.btn-default.more(@click.prevent="setPage(currPage+1)" v-bind:class="{'disabled': (currPage === totalPage)}")
      span.glyphicon.glyphicon-triangle-right
    button.btn.btn-default.more(@click='setPaginationSec(currPaginationSec+1)' v-if='currPaginationSec !== totalSection')
      span.glyphicon.glyphicon-forward
</template>

<script>
import { select } from 'vue-strap'
export default {
  components: {
    'v-select': select
  },
  props: {
    countOfPage: {
      type: Number,
      default: 50
    },
    currPage: {
      type: Number,
      twoway: true,
      default: 1
    },
    countOfPagination: {
      type: Number,
      default: 5,
      twoway: true
    },
    currPaginationSec: {
      type: Number,
      twoway: true,
      default: 1
    },
    targetAry: {
      type: Array,
      twoway: true,
      default: () => []
    }
  },
  data () {
    return {
      countOfPageOptions: [
        {val: 10, label: '10'},
        {val: 25, label: '25'},
        {val: 50, label: '50'},
        {val: 100, label: '100'}
      ]
    }
  },
  computed: {
    paginationStart () {
      return (this.currPaginationSec - 1) * this.countOfPagination
    },
    totalSection () {
      return Math.ceil(this.totalPage / this.countOfPagination)
    },
    totalPage () {
      return Math.ceil(this.targetAry.length / this.countOfPage)
    },
    totalPageAry () {
      let ary = []
      for (let i = 0; i < this.totalPage; i++) {
        ary.push(i)
      }
      return ary
    }
  },
  methods: {
    resetPagination () {
      const amount = (this.currPage - 1) * this.countOfPage
      const max = this.targetAry.length
      if (amount > max) {
        this.currPage = 1
        this.currPaginationSec = 1
      }
      // console.log(
      //   this.currPage,
      //   this.currPaginationSec,
      //   this.countOfPage,
      //   (this.currPage - 1) * this.countOfPage
      // )
    },
    setPage: function (idx) {
      if (idx <= 0 || idx > this.totalPage) {
        return
      }
      this.currPage = idx
      if (idx > this.currPaginationSec * this.countOfPagination) {
        this.setPaginationSec(this.currPaginationSec + 1)
      } else if (idx <= (this.currPaginationSec - 1) * this.countOfPagination) {
        this.setPaginationSec(this.currPaginationSec - 1)
      }
    },
    setPaginationSec (idx) {
      if (idx <= 0 || idx > this.totalSection) {
        return
      }
      this.currPaginationSec = idx
      this.currPage = (idx - 1) * this.countOfPagination + 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.pagination_section{
  & button{
    outline:none;
    &:focus{
      outline:none
    }
  }
  padding: 15px;
  text-align: center;
  .more {
    width: 50px;
  }
  .arrow {
    width: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// Pagination.vue?037c5313